import rootReducer from './rootReducer';
import configureStore from './configureStore';

const { store, persistor } = configureStore(rootReducer);

export {
  store,
  persistor,
};
